import { useEffect, useState } from "react"

/**
 * Откладывает применение быстро меняющегося значения. Нужен там, где каждое
 * нажатие клавиши иначе превращается в отдельный запрос к серверу: партнёрские
 * чтения ограничены по частоте и отвечают `rate_limit_exceeded`, поэтому
 * набор идентификатора в поле фильтра не должен стоить десятков вызовов.
 */
export const useDebouncedValue = <T,>(value: T, delayMs = 400): T => {
    const [debounced, setDebounced] = useState(value)

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delayMs)

        return () => clearTimeout(timer)
    }, [delayMs, value])

    return debounced
}
